import { useAutocompleteSource } from '@eas/common-web';
import { DictEducationFormAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useEducationForms() {
  return useAutocompleteSource<DictEducationFormAutocomplete>({
    url: `${EvidenceApiUrl.DICT_EDUCATION_FORM}/autocomplete`,
  });
}
